<template>
  <component :is="target" />
</template>

<script>

import MaterialPc from './modules/material-pc'
import MaterialPhone from './modules/material-phone'

export default {
  components: {
    MaterialPc,
    MaterialPhone
  },
  data () {
    return {
      isMobile: false
    }
  },
  computed: {
    target () {
      return this.isMobile ? 'MaterialPhone' : 'MaterialPc'
    }
  },
  created () {
    this.isMobile = this.isMobileType()
  },
  mounted () {
    if (this.$route?.meta?.title) {
      document.title = this.$route.meta.title
    }
    this.pageResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.pageResize)
  },
  methods: {
    isMobileType () {
      let isPhone = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	    return isPhone && isPhone.length > 0 ? true : false
    },
    pageResize () {
      window.addEventListener('resize', () => {
        this.isMobile = this.isMobileType()
      })
    }
  }
}
</script>
